/* Luna Fashion House, article product cards. Keeps the price on each card current from the live product
   (public /products/<handle>.js) and marks a card sold out. Installed as assets/luna-cards.js, loaded from
   theme.liquid after luna-cards.css. The price written into the article HTML stays as the fallback. */
(function () {
  var spans = document.querySelectorAll('.luna-card__price[data-luna-price]');
  if (!spans.length || !window.fetch) return;
  var byHandle = {};
  spans.forEach(function (s) { var h = s.getAttribute('data-luna-price'); (byHandle[h] = byHandle[h] || []).push(s); });
  var fmt = function (cents, currency) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', maximumFractionDigits: 0 }).format(cents / 100); } catch (e) { return '$' + Math.round(cents / 100); } };
  Object.keys(byHandle).forEach(function (h) {
    fetch('/products/' + h + '.js', { credentials: 'same-origin', headers: { accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      var available = p.variants.some(function (v) { return v.available; });
      var min = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      byHandle[h].forEach(function (s) {
        s.textContent = fmt(min, currency);
        if (!available) { s.textContent += ', sold out'; s.classList.add('luna-card__price--soldout'); }
      });
    }).catch(function () {});
  });
})();
